export enum ContactTypeEnumEntity {
  ARCHITECT = 1,
  CLIENT = 2,
  TRADER = 3
}

export enum StorageKeyEnum {
  JB_GLASS_USER_INFO = "jb_glass_user_info",
}

export enum ContactTypeNameEnum {
  ARCHITECT = "Architect",
  CLIENT = "Client",
  TRADER = "Trader",
}

export enum AddressesProviderAutoCompleteTypeEnumEntity {
  ADDRESS_COMPANY = 'ADDRESS_COMPANY',
  PINCODE = 'PINCODE',
  CITY = 'CITY'
}

export enum AddressesProviderEnum {
  GOOGLE = 'google',
  MAPBOX = 'mapbox'
}

export enum AddressesProviderSearchFieldEnum {
  COMPANY_NAME = "company_name",
  ADDRESS_LINE_1 = "address_line_1",
  CITY = "city",
  PIN_CODE = "pin_code",
}